// frontend/src/utils/formatText.js

export const formatText = (text) => {
  if (!text) return '';

  let formatted = text;

  // Fix words with unwanted spaces (e.g., "M igraine" → "Migraine")
  // formatted = formatted.replace(/([a-zA-Z])\s+(?=[a-zA-Z])/g, '$1');

  // Ensure numbered/bulleted lists start on new lines
  // formatted = formatted.replace(/(\d+\.\s\*\*)/g, '\n$1');
  // formatted = formatted.replace(/(\s[-•]\s)/g, '\n$1');

    // Convert **bold text** to <strong>bold text</strong>
    formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  return formatted.trim();
};